import * as React from "react";

import Modal from "../modal/modal";
import { BodyContainer } from "../modal/modal-style";
import { withTheme } from "styled-components";

import { RuntimeTheme } from "webapp/lib/theme/default-theme";
import { showBasicActionModal } from "designer/ui/smart/modals/modals";
import { PaymentInfoController } from "./payment-info-controller";
import { CardInfo } from "./payment-info";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";
import { confirmCardSetup, getPaymentMethodForStripeCard } from "./payment-info-utils";
import { PaymentRequestInfo } from "./stripe-pay-button";

interface Props {
    theme: RuntimeTheme;
    setupIntentClientSecret: string;
    paymentRequestInfo: PaymentRequestInfo;
    onCompletion?: (paymentMethod: string | false) => void;
    modals: SimpleModalContextProps;
}

interface State {
    cardInfo: CardInfo | undefined;
    stripeCard: any | undefined;
    canAcceptCard: boolean;
    updating: boolean | undefined;
}

async function showPaymentUpdateError(errorMessage: string): Promise<void> {
    await showBasicActionModal("Could not update payment information", errorMessage, "OK");
}

class PaymentInfoModalImpl extends React.PureComponent<Props, State> {
    public state: State = {
        cardInfo: undefined,
        stripeCard: undefined,
        canAcceptCard: false,
        updating: false,
    };

    private complete(paymentMethod: string | false) {
        const { onCompletion } = this.props;
        if (onCompletion) {
            onCompletion(paymentMethod);
        }
    }

    private onCancel = () => {
        this.complete(false);
    };

    private updateCard = (cardInfo: CardInfo, stripeCard: any) => {
        this.setState({ cardInfo, stripeCard });
    };

    private updateCanAccept = (canAccept: boolean) => {
        this.setState({ canAcceptCard: canAccept });
    };

    private onError = (msg: string) => {
        this.props.modals.DEPRECATED_removeAllModals();
        void showPaymentUpdateError(msg);
        this.complete(false);
    };

    private onAccept = async () => {
        const { setupIntentClientSecret } = this.props;
        const { cardInfo, stripeCard } = this.state;

        if (cardInfo === undefined || stripeCard === undefined) return;

        this.setState({ updating: true });
        const paymentMethodRes = await getPaymentMethodForStripeCard(cardInfo, stripeCard);
        if (paymentMethodRes.isErr()) {
            return this.onError(paymentMethodRes.error);
        }

        const cardSetupRes = await confirmCardSetup(setupIntentClientSecret, paymentMethodRes.value);
        if (cardSetupRes.isErr()) {
            return this.onError(cardSetupRes.error);
        } else {
            this.props.modals.DEPRECATED_removeAllModals();
            this.complete(cardSetupRes.value);
        }
    };

    private onPayButton = async (paymentMethod: string) => {
        const { setupIntentClientSecret } = this.props;

        const cardSetupRes = await confirmCardSetup(setupIntentClientSecret, paymentMethod);
        if (cardSetupRes.isErr()) {
            this.onError(cardSetupRes.error);
            return false;
        } else {
            this.props.modals.DEPRECATED_removeAllModals();
            this.complete(cardSetupRes.value);
            return true;
        }
    };

    public render(): React.ReactNode {
        const { updating, cardInfo, canAcceptCard } = this.state;
        const canAccept = !updating && cardInfo !== undefined && canAcceptCard;
        return (
            <Modal
                height="auto"
                width={440}
                title={"Update Payment Info"}
                canAccept={canAccept}
                onAccept={this.onAccept}
                onClose={this.onCancel}
                animate={false}
                acceptText={this.state.updating ? "Updating" : "Update"}>
                <BodyContainer>
                    <PaymentInfoController
                        onPayButton={this.onPayButton}
                        onCanAcceptChange={this.updateCanAccept}
                        onUpdateCard={this.updateCard}
                        padTop={true}
                        cardError={false} // TODO: This should be hooked up to the error flow
                        paymentRequestInfo={this.props.paymentRequestInfo}
                    />
                </BodyContainer>
            </Modal>
        );
    }
}

const PaymentInfoModal = withModalProvider(withTheme(PaymentInfoModalImpl));
export default PaymentInfoModal;
